import React, { useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import api from '../lib/api';

const DEFAULT_FISCAL = {
  ragione_sociale: 'Betti S.R.L.',
  sede_legale: 'Via Mentana 19, Poggibonsi (SI)',
  piva_cf: '01589500527',
  cap_soc: '€ 10.000,00 i.v.',
  codice_sdi: '9SUB64Q',
  pec: 'bettisrl@pec.it',
};

const LABELS = {
  ragione_sociale: 'Ragione Sociale',
  sede_legale: 'Sede Legale',
  piva_cf: 'P. IVA / C.F.',
  cap_soc: 'Cap. Soc.',
  codice_sdi: 'Codice SDI',
  pec: 'PEC',
};

const DatiFiscali = () => {
  const [data, setData] = useState(DEFAULT_FISCAL);

  useEffect(() => {
    api.get('/site-info')
      .then((r) => setData(r.data.fiscal || DEFAULT_FISCAL))
      .catch(() => setData(DEFAULT_FISCAL));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 lg:px-6 py-10 fade-in" data-testid="fiscal-page">
      <div className="flex items-center gap-3 mb-2">
        <FileText className="text-[#d62828]" size={28} />
        <h1 className="text-4xl font-black brand-text text-neutral-900">Dati Fiscali</h1>
      </div>
      <p className="text-neutral-600">Riferimenti aziendali per fatturazione e adempimenti.</p>

      <div className="mt-8 p-6 bg-white border border-neutral-200 rounded-lg">
        <dl className="grid sm:grid-cols-2 gap-y-4 gap-x-8 text-sm">
          {Object.entries(LABELS).map(([key, label]) => (
            (data[key] || '').toString().trim() ? (
              <div key={key} className="border-b border-neutral-100 pb-3" data-testid={`fiscal-${key}`}>
                <dt className="text-xs uppercase tracking-wider text-neutral-500 font-bold">{label}</dt>
                <dd className="text-neutral-800 font-medium mt-1">{data[key]}</dd>
              </div>
            ) : null
          ))}
        </dl>
      </div>
    </div>
  );
};

export default DatiFiscali;
